import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b226292"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "area-container" }

import { ref, watch } from 'vue'
import { getCategoryDictByParentId, getCategoryDictTree } from '@/api/common'
import { CascaderProps } from 'element-plus'
import { ERR_SUCCESS } from '@/api/config'
interface CascaderOption { id: number; value: string; label: string; leaf?: boolean; children?: CascaderOption[] }


export default /*#__PURE__*/_defineComponent({
  __name: 'AreaCascader',
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const selectedAreaValue = ref([])
const options = ref<CascaderOption[]>([])

async function fetchChildNodes (nodeId: number) {
  try {
    const response = await getCategoryDictTree(nodeId)
    const { result } = response

    const processNode = (node: any): any => {
      const leaf = !node.children || node.children.length === 0

      return {
        id: node.id,
        value: node.value,
        label: node.label,
        leaf: leaf,
        children: !leaf ? node.children.map(processNode) : []
      }
    }

    if (result && result.length > 0) {
      return result[0].children.map(processNode)
    } else {
      return []
    }
  } catch (error) {
    console.error('Error fetching child nodes:', error)
    return []
  }
}

const cascaderProp: CascaderProps = {
  multiple: true,
  checkStrictly: true,
  emitPath: false,
  lazy: true,
  lazyLoad: (node, resolve) => {
    const nodeId = node.data?.id as number
    if (!nodeId) {
      resolve([])
      return
    }

    fetchChildNodes(nodeId).then((children) => {
      if (node.data) {
        node.data.children = children
      }
      resolve(children)
    }).catch(() => {
      resolve([])
    })
  }
}

// eslint-disable-next-line no-undef,func-call-spacing
const emit = __emit

async function fetchData () {
  try {
    const { code, result } = await getCategoryDictByParentId(12)
    if (code === ERR_SUCCESS && result) {
      options.value = result.map(item => ({
        id: item.id,
        value: item.value,
        label: item.label,
        leaf: false
      }))
    } else {
      console.error('Error in API response', result)
    }
  } catch (error) {
    console.error('Error fetching initial data:', error)
  }
}

fetchData()

watch(selectedAreaValue, (newVal) => {
  return emit('update:modelValue', newVal)
})

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_cascader, {
      modelValue: selectedAreaValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAreaValue).value = $event)),
      options: options.value,
      props: cascaderProp,
      "show-all-levels": true,
      clearable: "",
      filterable: "",
      placeholder: "请选择地区",
      style: {"width":"100%"}
    }, null, 8, ["modelValue", "options"])
  ]))
}
}

})